var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 45,
    viewBox: "0 0 29 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 14.6875C25.3989 14.6875 28.5469 11.5395 28.5469 7.65625C28.5469 3.773 25.3989 0.625 21.5156 0.625C17.6324 0.625 14.4844 3.773 14.4844 7.65625C14.4844 11.5395 17.6324 14.6875 21.5156 14.6875Z",
    fill: "#0055FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6719 44.375H3.03125C1.5 44.375 0.25 43.125 0.25 41.5938V8.04688C0.265625 6.53125 1.48438 5.3125 3 5.3125H19.6875C21.2188 5.3125 22.4688 6.5625 22.4688 8.09375V24.1875H8.84375C8.07812 24.1875 7.45312 24.8125 7.45312 25.5781V29.8125H22.4688V41.5938C22.4531 43.125 21.2031 44.375 19.6719 44.375ZM3 6.875C2.34375 6.875 1.82812 7.40625 1.82812 8.04688V41.5938C1.82812 42.2656 2.375 42.8125 3.04688 42.8125H19.6875C20.3594 42.8125 20.9062 42.2656 20.9062 41.5938V31.375H5.89062V25.5781C5.89062 23.9531 7.21875 22.625 8.84375 22.625H20.9062V8.09375C20.9062 7.42188 20.3594 6.875 19.6875 6.875H3Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7812 31.375H21.6719V29.8125H25.7812C26.5469 29.8125 27.1719 29.1875 27.1719 28.4219V25.5937C27.1719 24.8281 26.5469 24.2031 25.7812 24.2031H21.6719V22.6406H25.7812C27.4062 22.6406 28.7344 23.9687 28.7344 25.5937V28.4219C28.7344 30.0469 27.4062 31.375 25.7812 31.375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6719 31.375H5.875V25.5781C5.875 23.9531 7.20313 22.625 8.82813 22.625H21.6719V24.1875H8.82813C8.0625 24.1875 7.4375 24.8125 7.4375 25.5781V29.8125H21.6719V31.375Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 10.8438H7.39062C6.95312 10.8438 6.60938 10.5 6.60938 10.0625C6.60938 9.625 6.95312 9.28125 7.39062 9.28125H15.3125C15.75 9.28125 16.0938 9.625 16.0938 10.0625C16.0938 10.5 15.75 10.8438 15.3125 10.8438Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbox);
export default __webpack_public_path__ + "static/media/inbox.09e490f2c70de201c87e32f2ebcb5bd5.svg";
export { ForwardRef as ReactComponent };